var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddNotes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 1a1 1 0 0 1 2 0v5H7zM15 1a1 1 0 0 1 2 0v5h-2zM23 1a1 1 0 0 1 2 0v5h-2zM11 2h2v2h-2zM19 2h2v2h-2zM2 5a3 3 0 0 1 3-3v2a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h7v2H5a3 3 0 0 1-3-3zM28 14h2V5a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M24.17 17.022a3.4 3.4 0 0 1 4.808 4.807l-8.485 8.485a1 1 0 0 1-.432.255l-4.75 1.357a1 1 0 0 1-1.237-1.236l1.358-4.75a1 1 0 0 1 .254-.433zm3.394 1.415a1.4 1.4 0 0 0-1.979 0l-.311.31 1.979 1.98.31-.312a1.4 1.4 0 0 0 0-1.979m-10.28 8.301 6.576-6.576 1.979 1.978-6.577 6.577-1.202.343-1.12-1.12z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10h9v2h-9zM8 15h11v2H8zM10 10v2H8v-2zM12 20v2H8v-2z"
})));
export default SvgAddNotes;